// src/services/axiosInstance.js
import axios from "axios";
import commonStore from "../Store/marco/commonStore";
import handleAPIError, { MESSAGE_CODES } from "./toast";

const URLList = {
  dev: "https://devapi.evercomm.com.sg",
  dev2: "https://devapi2.evercomm.com.sg",
  // stage: "https://nxmapstgapi.evercomm.com.sg",
  stage: "https://nxmaptestapi.evercomm.com.sg",
  stageTW: "https://nxmaptestapi.evercomm.com.sg",
  prod: "https://nxmapgapi.evercomm.com.sg",
  prodIp: "https://nxmapapi2.evercomm.com.sg",
};

const env = process.env.REACT_APP_ENV || "dev"; // 預設為 dev 環境
const baseURL = URLList[env] || URLList.dev;

const axiosInstance = axios.create({
  baseURL,
  timeout: 30000,
  headers: {
    Accept: "application/json",
  },
});

axiosInstance.interceptors.request.use((config) => {
  if (!config.skipAuth) {
    const token = config.authToken || commonStore.token;
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    config.requestAuthToken = token || "";
  } else {
    // 確保真的移除掉
    delete config.headers["Authorization"];
    config.requestAuthToken = "";
  }
  delete config.authToken;
  return config;
});

let isHandlingAuthError = false;

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.log(error);
    const status = error?.response?.status;
    const requestToken = error?.config?.requestAuthToken || "";
    const isCurrentAuthenticatedRequest =
      !error?.config?.skipAuth &&
      Boolean(requestToken) &&
      requestToken === commonStore.token;

    // 只有在有 response 的情況下才判斷 status
    if (
      (status === 498 || status === 401) &&
      isCurrentAuthenticatedRequest &&
      !isHandlingAuthError
    ) {
      isHandlingAuthError = true;
      const failedToken = requestToken;

      try {
        if (status === 498) {
          handleAPIError(error, {
            scenarioCode: MESSAGE_CODES.SESSION_EXPIRED,
            throwError: false,
            toastOptions: {
              toastId: MESSAGE_CODES.SESSION_EXPIRED
            }
          });
        } else if (status === 401) {
          handleAPIError(error, {
            scenarioCode: MESSAGE_CODES.SESSION_REPLACED,
            throwError: false,
            toastOptions: {
              toastId: MESSAGE_CODES.SESSION_REPLACED
            }
          });
        }
      } catch (e) {
        console.log("處理驗證錯誤時發生異常:", e);
      }

      setTimeout(() => {
        if (commonStore.token === failedToken) {
          commonStore.expireLogout();
        }
        isHandlingAuthError = false;
      }, 2000);
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
